export const SOFTWARE_VALUES = [
  'Intuit ProConnect Tax Online',
  'Intuit ProSeries Tax',
  'Intuit - Lacerte Tax',
  'Wolters Kluwer - CCH Axcess Tax',
  'CCH - Pro Systems FX',
  'Thomson Reuters - GoSystem Tax RS',
  'Thomson Reuters - UltraTax CS',
  'Drake Software - Drake Tax',
  'CCH SFS - ATX',
  'CCH SFS - TaxWise',
  'SurePrep',
  'Workpaper CS',
  'Engagement',
  'Caseware',
  'My Tax Prep Office',
  'TaxAct Professional',
  'Taxslayer',
] as const

export const SUPPLEMENTAL_SOFTWARE_VALUES = [
  'SurePrep',
  'Caseware',
  'Engagement',
  'Workpaper CS',
] as const

export const PRO_SPECIALTY_VALUES = [
  'Individual',
  'Farming/Agriculture (Sch F)',
  'Foreign (Non-residents)',
  'Pass Through Entities',
  'Estates/Trusts',
  'Non-Profits',
  '1065',
  '1120',
  'ITIN',
  'Business (1065/1120S/1120)',
  '1120S',
  'Personal Reviewer',
  'Business Reviewer',
  'Tax Dissolution Services',
  'Bookkeeping',
  'Crypto',
  'High Net Worth Individuals',
  'Cannabis',
] as const

export const STATE_VALUES = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
  'Washington D.C.',
] as const
